if (!customElements.get('banner-slider-component')) {
  class BannerSliderComponent extends HTMLElement {
    constructor() {
      super();
      this.currentIndex = 0;
      this.autoplayInterval = null;
    }

    connectedCallback() {
      this.track = this.querySelector('.banner-slider__track');
      this.slides = this.querySelectorAll('.banner-slider__slide');
      this.dots = this.querySelectorAll('.banner-slider__dot');
      this.prevButton = this.querySelector('.banner-slider__arrow--prev');
      this.nextButton = this.querySelector('.banner-slider__arrow--next');

      if (this.slides.length <= 1) return;

      this.bindEvents();
      this.initAutoplay();
    }

    disconnectedCallback() {
      this.stopAutoplay();
    }

    bindEvents() {
      if (this.prevButton) {
        this.prevButton.addEventListener('click', () => this.goToPrev());
      }

      if (this.nextButton) {
        this.nextButton.addEventListener('click', () => this.goToNext());
      }

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.dataset.slideIndex, 10);
          this.goToSlide(index);
        });
      });

      // Pause autoplay on hover/focus
      this.addEventListener('mouseenter', () => this.stopAutoplay());
      this.addEventListener('mouseleave', () => this.initAutoplay());
      this.addEventListener('focusin', () => this.stopAutoplay());
      this.addEventListener('focusout', () => this.initAutoplay());

      // Keyboard navigation
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') {
          this.goToPrev();
        } else if (e.key === 'ArrowRight') {
          this.goToNext();
        }
      });
    }

    initAutoplay() {
      this.stopAutoplay();
      const autoplay = this.track.dataset.autoplay === 'true';
      if (!autoplay) return;

      const speed = (parseInt(this.track.dataset.speed, 10) || 5) * 1000;
      this.autoplayInterval = setInterval(() => this.goToNext(), speed);
    }

    stopAutoplay() {
      if (this.autoplayInterval) {
        clearInterval(this.autoplayInterval);
        this.autoplayInterval = null;
      }
    }

    goToSlide(index) {
      if (index === this.currentIndex) return;

      this.slides[this.currentIndex].classList.remove(
        'banner-slider__slide--active',
      );
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.remove(
          'banner-slider__dot--active',
        );
      }

      this.currentIndex = index;

      this.slides[this.currentIndex].classList.add(
        'banner-slider__slide--active',
      );
      if (this.dots[this.currentIndex]) {
        this.dots[this.currentIndex].classList.add(
          'banner-slider__dot--active',
        );
      }

      // Announce to screen readers
      this.slides[this.currentIndex].focus({ preventScroll: true });
    }

    goToNext() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    goToPrev() {
      const prevIndex =
        (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }
  }

  customElements.define('banner-slider-component', BannerSliderComponent);
}
